import { render, staticRenderFns } from "./GivCard.vue?vue&type=template&id=73c59be2&"
import script from "./GivCard.vue?vue&type=script&lang=js&"
export * from "./GivCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports